import React from "react";
import { connect } from "react-redux";
import DataGrid, { Column, LoadPanel, Scrolling, FilterRow } from "devextreme-react/data-grid";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";
import { getPlanGroups} from "../../../../../../Plan/store/actions";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #planGridContainer": {
      height: "320px"
    }
  }
};

class SelectGroupTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedPlanItems: [],
      focusedPlan: -1,
      focusedRowIndex: -1
    };

    this.selectPlanItems = this.selectPlanItems.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    this.dataGridRef = React.createRef();
  }

  selectPlanItems({ selectedRowsData }) {
    this.setState({ selectedPlanItems: selectedRowsData });
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  onRowClick(e) {
    const {onSelectedPlan} = this.props;
    const focusedPlan = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedPlan, focusedRowIndex });
    onSelectedPlan(focusedPlan);
    //console.log(focusedPlan);
  }

  render() {
    const {
      selectedPlanItems,
      focusedRowIndex,
      focusedPlan
    } = this.state;
    const {
      selectedPlan,
      actualGroups,
      classes
    } = this.props;
    const { root, controls } = classes;

    return (
      <div className={root}>
            <DataGrid
              elementAttr={{
                id: "planGridContainer"
              }}
              ref={this.dataGridRef}
              wordWrapEnabled={true}
              dataSource={actualGroups}
              onSelectionChanged={this.selectPlanItems}
              focusedRowEnabled
              errorRowEnabled={false}
              onRowClick={this.onRowClick}
              focusedRowIndex={focusedRowIndex}
              selection={{ mode: 'single' }}
              showBorders={true}
            >
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled/>
            </DataGrid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actualGroups: state.programs.actualGroups
});

export default connect(
  mapStateToProps
)(withStyles(styles)(SelectGroupTable));
